import {bindStageInput} from './input-binder/bindStageInput'
import {bindKeyboardInput} from './input-binder/bindKeyboardInput'

export function createKonvaInputAdapter({stage, editor, interaction, runtime}) {
    const isTextEditing = () => runtime?.getUiState().textEditing != null
    const unbindStage = bindStageInput(stage, editor, interaction, {isTextEditing, runtime})
    const unbindKeyboard = bindKeyboardInput(editor, stage, interaction, {isTextEditing})

    return () => {
        unbindStage?.()
        unbindKeyboard?.()
    }
}
